import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/containers/general/header/index.js